<template>
  <div class="content user-info" :class="{ 'user-info__electron': isElectron }">
    <ul class="tabs-wrap">
      <li
        v-for="item in navList"
        :key="item.component"
        @click="activeTab = item.component"
        :class="{ active: activeTab === item.component }"
      >
        {{ item.name }}
        <span
          v-if="item.component === 'ParentBinding' && pendingBindCount > 0"
          class="badge"
          >{{ pendingBindCount }}</span
        >
      </li>
    </ul>
    <div class="content-wrap">
      <keep-alive> <component :is="activeTab"> </component></keep-alive>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import { getPendingBindCount } from "@saas/service-api/src/parent-binding";
import {
  USER_INFO_TABS,
  resolveUserInfoTabComponent,
  getUserInfoTabQueryValue,
} from "./tab-config";
import BasicInfo from "./components/BasicInfo";
import Account from "./components/Account.vue";
import Address from "./components/Address.vue";
import ParentBinding from "../parent-binding/BindingConfirm.vue";
export default {
  data: function () {
    return {
      navList: USER_INFO_TABS,
      activeTab: "BasicInfo",
      isElectron: window.isElectron,
      pendingBindCount: 0,
    };
  },
  mounted() {
    EventBus.$off("user-info-page-change-tab");
    EventBus.$on("user-info-page-change-tab", (key) => {
      if (this.tabValList.includes(key)) {
        this.activeTab = key;
        this.syncRouteQuery(key);
      }
    });
    this.syncTabFromRoute(this.$route.query.tab);
    this.fetchPendingBindCount();
  },
  watch: {
    "$route.query.tab"(tab) {
      this.syncTabFromRoute(tab);
    },
    activeTab(tab) {
      this.syncRouteQuery(tab);
    },
  },
  methods: {
    syncTabFromRoute(tab) {
      const targetComponent = resolveUserInfoTabComponent(tab);
      if (targetComponent !== this.activeTab) {
        this.activeTab = targetComponent;
      }
    },
    syncRouteQuery(component) {
      const tab = getUserInfoTabQueryValue(component);
      if (this.$route.query.tab === tab) return;
      this.$router
        .replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            tab,
          },
        })
        .catch(() => {});
    },
    fetchPendingBindCount() {
      getPendingBindCount()
        .then((res) => {
          this.pendingBindCount = res.data || 0;
        })
        .catch(() => {});
    },
  },
  components: {
    BasicInfo,
    Account,
    Address,
    ParentBinding,
  },
  computed: {
    tabValList() {
      return this.navList.map((item) => item.component);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  .tabs-wrap {
    display: flex;
    padding: 10px;
    background: #ffffff;
    // border-bottom: 1px solid #ededed;
    // border-radius: 8px 8px 0 0;
    background: unset;
    border: none;
    li {
      position: relative;
      padding: 10px;
      cursor: pointer;
      font-size: 14px;
      margin-right: 10px;
      .badge {
        position: absolute;
        top: 2px;
        right: -6px;
        min-width: 16px;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        font-size: 11px;
        font-weight: 600;
        color: #fff;
        background: #ef4444;
        border-radius: 8px;
        text-align: center;
      }
    }
    .active {
      position: relative;
      font-weight: 600;
      color: #0d1400;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: -3px;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 3px;
      }
    }
  }
  .content-wrap {
    // background: #ffffff;
    // padding: 20px;
    display: flex;
    flex: 1;
    border-radius: 0 0 8px 8px;
  }
}
.user-info__electron {
  .tabs-wrap {
    background: unset;
    border: none;
  }
}
</style>
